// Utilitários compartilhados - funções auxiliares puras

/**
 * Formata data para exibição
 */
export const formatDate = (
  date: string | Date | null | undefined,
  format = 'dd/MM/yyyy'
): string => {
  if (!date) return '';

  let day: number;
  let month: number;
  let year: number;

  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
    const parts = date.split('T')[0].split('-');
    if (parts.length === 3) {
      year = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10);
      day = parseInt(parts[2], 10);
      if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) return '';
    } else {
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return '';
      day = d.getDate();
      month = d.getMonth() + 1;
      year = d.getFullYear();
    }
  } else {
    const d = new Date(date as string | Date);
    if (Number.isNaN(d.getTime())) return '';
    day = d.getDate();
    month = d.getMonth() + 1;
    year = d.getFullYear();
  }

  const dayStr = String(day).padStart(2, '0');
  const monthStr = String(month).padStart(2, '0');
  const yearStr = String(year);

  return format
    .replace('dd', dayStr)
    .replace('MM', monthStr)
    .replace('yyyy', yearStr);
};

export const truncate = (
  text: string | null | undefined,
  maxLength: number,
  suffix = '...'
): string => {
  if (!text || text.length <= maxLength) return text ?? '';
  return text.substring(0, maxLength) + suffix;
};

export const debounce = <T extends (...args: unknown[]) => void>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout>;
  return function executedFunction(...args: Parameters<T>) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const cn = (...classes: (string | Record<string, boolean> | undefined | null)[]): string => {
  return classes
    .filter(Boolean)
    .map((cls) => {
      if (typeof cls === 'string') return cls;
      if (typeof cls === 'object' && cls !== null) {
        return Object.entries(cls)
          .filter(([, condition]) => condition)
          .map(([className]) => className)
          .join(' ');
      }
      return '';
    })
    .join(' ')
    .trim();
};

export { isTutorialRoute, shouldShowCategoryNavbar, shouldShowPageNavbar } from './routeUtils';

export default {
  formatDate,
  truncate,
  debounce,
  slugify,
  isValidEmail,
  cn,
};
